/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-banner' ).each( function() {
        $( this ).find( '.hero-banner__slider' ).slick( {
          dots: false,
          arrows: true,
          prevArrow: $( this ).find( '.prev-slide' ),
          nextArrow: $( this ).find( '.next-slide' ),
          variableWidth: true,
          infinite: true,
          centerMode: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                variableWidth: false,
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                variableWidth: false,
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 640,
              settings: {
                variableWidth: false,
                slidesToShow: 1,
              },
            },
          ],
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
